import React from 'react';
import { TalentPoolViewRendererProps } from '../types';

import Desktop from './Desktop';

function ViewRenderer(props: TalentPoolViewRendererProps) {
  return <Desktop {...props} />;
}

export default ViewRenderer;
